import React from "react";
import Box from "@material-ui/core/Box";

import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
  root: {
    // Add bottom margin if element below
    "&:not(:last-child)": {
      marginBottom: "1rem",
    },
  },
  subtitle: {
    // Subtitle text generally isn't very long
    // so usually looks better to limit width.
    maxWidth: 1200,
    // So we can have max-width but still
    // have alignment controlled by text-align.
    display: "inline-block",
  }
}));
  
function SectionHeader(props) {
  const classes = useStyles();
  const { subtitle, title, size, className, ...otherProps } = props;


  return (<div style={{marginLeft: 40, marginRight: 40, paddingBottom: 15}}>
    <Box className={classes.root + (props.className ? ` ${props.className}` : "")}
      {...otherProps}
    >
      {title && (
        <Typography
          variant={`h${size}`}
          gutterBottom={props.subtitle ? true : false}
        >
          <span style={{fontWeight:600}}>{title}</span>
        </Typography>
      )}

      {subtitle && (
        <Typography variant="subtitle1" className={classes.subtitle}>
          {subtitle}
        </Typography>
      )}
    </Box></div>
  );
}

export default SectionHeader;
